import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { scrollToSection } from '../utils/scrollTo';

const About: React.FC = () => {
  const { setRef, isVisible } = useIntersectionObserver();
  return (
    <section id="about" ref={setRef('about')} className="about-section">
      <div className="about-inner">

        {/* Left: text content */}
        <div className={`sf ${isVisible('about') ? 'vis' : ''}`}>
          <div className="eyebrow-dark">Just feel the future</div>
          <h2 className="section-h2">Bringing Your Ideas &amp; Innovations to Life</h2>
          <p className="about-text-body">
            At Gulf Fibertech Industries, we pioneer the manufacturing of high-quality GRP (Glass Reinforced Plastic) products. With lot of working experience, our solutions are designed for durability, versatility, and performance in the most demanding environments.
          </p>
          <p className="about-text-body">
            From oil &amp; gas facilities to modern architectural projects across the UAE and beyond — we deliver precision-engineered GRP components that meet and exceed global standards.
          </p>
          <div className="about-features">
            {['Simplicity in Design with Practicality in Mind', 'High Level of Quality Control'].map(f => (
              <div key={f} className="about-feature" dangerouslySetInnerHTML={{ __html: f }} />
            ))}
          </div>
          <button className="btn-yellow" onClick={() => scrollToSection('contact')}>About Company →</button>

          {/* Counters row */}
          {/* <div className="about-counters-row">
            {[{ n: '500+', l: 'Completed Projects' }, { n: '20+', l: 'Years Experience' }, { n: '98%', l: 'Satisfaction Rate' }, { n: '30+', l: 'Countries Served' }].map(c => (
              <div key={c.l} className="about-counter">
                <div className="about-counter-num">{c.n}</div>
                <div className="about-counter-label">{c.l}</div>
              </div>
            ))}
          </div> */}
        </div>

        {/* Right: image + floating accent */}
        <div className={`about-img-wrap sf ${isVisible('about') ? 'vis' : ''}`} style={{ transitionDelay: '0.15s' }}>
          <img className="about-main-img"
            src="../sec-hero-collage-with-4-products.webp"
            alt="GRP Manufacturing" />
          {/* <img className="about-mini-img"
            src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=300&q=80"
            alt="Quality control" /> */}
          {/* <div className="about-accent">
            <div className="about-accent-num">20+</div>
            <div className="about-accent-label">Years of Excellence</div>
          </div> */}
        </div>
      </div>
    </section>
  );
};
export default About;
